export const localized = `_locale_code == '${process.env.NEXT_PUBLIC_SANITY_LOCALE}'`;

export const active = `status == 'active'`;

export const published = `!(_id in path("drafts.**"))`;
